<template>
  <div class="hello page-roster">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="flex">
          <div class="exactDate flex aic">
            <div class="flname">记账月份&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div class="fast-switch" @click="fastWwitch(0, 'bookDate')">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="block">
              <el-date-picker
                v-model="bookDate"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                :clearable="false"
                :picker-options="pickerOptions"
                @change="selectMonth"
              ></el-date-picker>
            </div>
            <div class="fast-switch" @click="fastWwitch(1, 'bookDate')">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="exactDate flex aic">
            <div class="flname">归属月份&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div class="fast-switch" @click="fastWwitch(0, 'belongMonth')">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="block">
              <el-date-picker
                v-model="belongMonth"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                :clearable="
                  strTableId == 'XZ_emp_FnncProjectInvoice' ||
                  strTableId == 'XZ_emp_FnncProfit'
                    ? true
                    : false
                "
                :picker-options="pickerOptions"
                @change="selectMonth"
              ></el-date-picker>
            </div>
            <div class="fast-switch" @click="fastWwitch(1, 'belongMonth')">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <button
            class="exportButton"
            style="margin-left: 5px"
            @click="getImprtInfo"
          >
            搜索
          </button>
        </div>
      </div>
      <div class="top-right" style="margin-right: 30px">
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
        <!-- <button class="search" @click="queryImportState">导入</button> -->
        <!-- <button class="exportButton" @click="exportInfo">导出</button> -->
      </div>

      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div
            class="formScreenInput"
            v-if="
              strTableId != 'XZ_emp_FnncProCost' &&
              strTableId != 'XZ_emp_FnncProfit' &&
              strTableId != 'XZ_emp_FnncProjectInvoice'
            "
          >
            <div>姓名</div>
            <el-input size="small" v-model="empname"></el-input>
          </div>
          <div
            class="formScreenInput"
            v-if="
              strTableId != 'XZ_emp_FnncProCost' &&
              strTableId != 'XZ_emp_FnncProfit' &&
              strTableId != 'XZ_emp_FnncProjectInvoice'
            "
          >
            <div>身份证号</div>
            <el-input size="small" v-model="idn"></el-input>
          </div>
          <div
            class="formScreenInput"
            v-if="
              strTableId == 'XZ_emp_FnncProCost' ||
              strTableId == 'XZ_emp_FnncSocialInsu' ||
              strTableId == 'XZ_emp_FnncProfit' ||
              strTableId == 'XZ_emp_FnncProjectInvoice'
            "
          >
            <div>项目名称</div>
            <el-input size="small" v-model="custname2"></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="clear()">
            清空
          </button>
          <button class="search" @click="getImprtInfo()">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务工资清单</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/employee-fnnclst' }"
            >项目列表</el-breadcrumb-item
          >
          <el-breadcrumb-item v-if="strTableId == 'XZ_emp_FnncSocialInsu'"
            >项目收支表社保</el-breadcrumb-item
          >
          <el-breadcrumb-item v-else-if="strTableId == 'XZ_emp_FnncProCost'"
            >项目收支表费用</el-breadcrumb-item
          >
          <el-breadcrumb-item v-else-if="strTableId == 'XZ_emp_FnncProfit'"
            >利润表</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-else-if="strTableId == 'XZ_emp_FnncProjectInvoice'"
            >项目开票信息表</el-breadcrumb-item
          >
          <el-breadcrumb-item v-else>{{ custname }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable">
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick"
          v-show="
            strTableId != 'XZ_emp_Fnnc' && strTableId != 'XZ_emp_FnncSocialInsu'
          "
        >
          <el-tab-pane label="项目收支表费用" name="first"></el-tab-pane>
          <el-tab-pane label="利润表" name="second"></el-tab-pane>
          <el-tab-pane label="项目开票信息表" name="third"></el-tab-pane>
        </el-tabs>
        <div class="dlt_btn">
          <el-button type="warning" plain size="mini" @click="deleteHandle()"
            >清除导入数据</el-button
          >
        </div>
        <el-table
          :data="tableData"
          :max-height="tableHeight - 180"
          v-loading="listLoading"
          border
          style="width: 99%"
          :cell-style="columnStyle"
          :lazy="true"
        >
          <!-- <el-table-column align="center" type="selection" width="40"></el-table-column> -->
          <template v-for="(item, index) in tableTitle">
            <el-table-column
              :prop="item.StrColumId"
              :label="item.StrColumName"
              fit
              :key="index"
              :width="
                item.StrColumName == '备注'
                  ? 380
                  : item.StrColumName == 'NO'
                  ? 60
                  : item.StrColumName == '姓名'
                  ? 100
                  : 180
              "
              align="center"
              :fixed="
                item.StrColumName == '项目名称' || item.StrColumName == '姓名'
              "
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    item.StrColumName.indexOf('收入') != -1 ||
                    item.StrColumName.indexOf('金') != -1 ||
                    item.StrColumName.indexOf('支出') != -1 ||
                    item.StrColumName.indexOf('结余') != -1 ||
                    item.StrColumName.indexOf('商保') != -1 ||
                    item.StrColumName.indexOf('险') != -1 ||
                    item.StrColumName.indexOf('个人承担') != -1
                  "
                >
                  {{
                    !isNull2(scope.row[item.StrColumId])
                      ? Number(scope.row[item.StrColumId]).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2 }
                        )
                      : ""
                  }}
                </div>
                <div
                  v-else-if="
                    item.StrColumName == '插入时间' ||
                    item.StrColumName.indexOf('日期') != -1
                  "
                >
                  {{
                    isNull(scope.row[item.StrColumId])
                      ? ""
                      : scope.row[item.StrColumId].substring(0, 10)
                  }}
                </div>
                <div v-else-if="item.StrColumName == '身份证号码'">
                  {{ scope.row[item.StrColumId] }}
                </div>
                <div v-else>{{ scope.row[item.StrColumId] }}</div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" v-if="Number(totalcount) > 0">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 备注 -->
      <el-dialog :visible.sync="dialogVisible1" width="30%">
        <div class="diaTitle">添加备注</div>
        <el-input type="textarea" :rows="5" v-model="remarkText"></el-input>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible1 = false">取消</button>
          <button
            class="search"
            @click="confirmRemark()"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog :visible.sync="delDialog" width="580px">
        <div class="diaTitle">清除 {{ dltTableName }} 数据</div>
        <div class="flex impdata" style="margin: 20px 0">
          <div class="bookkeepingMonth">
            <div class="impTitle">记账月份:</div>
            <el-date-picker
              v-model="dltQuery.bookingRealMonth"
              type="month"
              placeholder="选择月"
              :picker-options="pickerOptions"
              value-format="yyyy-MM"
              @change="selectMonth"
            ></el-date-picker>
          </div>
          <div class="bookkeepingMonth">
            <div class="impTitle">归属月份:</div>
            <el-date-picker
              v-model="dltQuery.belongMonth"
              type="month"
              placeholder="选择月"
              :picker-options="pickerOptions"
              value-format="yyyy-MM"
              @change="selectMonth"
            ></el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="medium"
            style="margin-right: 15px"
            @click="delDialog = false"
            >取消</el-button
          >
          <!-- <el-popconfirm :title="'确认要删除  ' + dltTableName + '  的所有数据'" icon="el-icon-info" icon-color="red" @confirm="confirmDel"> -->
          <el-button
            size="medium"
            slot="reference"
            type="danger"
            @click="confirmDel"
            >确认删除</el-button
          >
          <!-- </el-popconfirm> -->
        </span>
      </el-dialog>
      <div class="tagArea">
        <!-- 导出 -->
        <el-dialog :visible.sync="dialogVisible4" width="800px">
          <div class="diaTitle">导出</div>
          <div>
            <div style="margin-bottom: 12px; margin-top: 15px; font-size: 16px">
              选择导出字段
            </div>
            <el-tabs type="border-card">
              <el-tab-pane label="导出字段">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                  >全选</el-checkbox
                >
                <div style="margin: 15px 0"></div>
                <el-checkbox-group
                  v-model="checkedFields"
                  @change="handleCheckedCitiesChange"
                >
                  <div class="fieldBox">
                    <el-checkbox
                      v-for="(field, index) in fields"
                      :label="field"
                      :key="index"
                      >{{ field }}</el-checkbox
                    >
                  </div>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
            <div
              class="historyFiled"
              v-show="historyFiled != [] && historyFiled.length > 0"
            >
              <p styele="margin-top:10px;">历史导出字段：</p>
              <el-radio-group
                v-model="radioVal"
                size="medium"
                v-for="(item, index) in historyFiled"
                :key="index + 'a'"
                @change="historyHandle"
              >
                <el-radio
                  :label="item.Key"
                  border
                  style="margin-bottom: 10px"
                  >{{ item.dtOputDate }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <button class="clear" @click="dialogVisible4 = false">取消</button>
            <button
              class="search"
              @click="confirmExport()"
              style="margin-left: 10px; font-weight: 600"
            >
              确定
            </button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "../../common";
import { parseTime } from "../../utils"; //格式化时间格式
export default {
  name: "HelloWorld",
  data() {
    return {
      delDialog: false,
      dltTableName: "",
      activeName: "first",
      dateVals: "",
      //归属月份
      belongMonth: parseTime(new Date(), "{y}-{m}"),
      //记账月份
      bookDate: parseTime(new Date(), "{y}-{m}"),
      //禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        firstDayOfWeek: 1,
      },
      strTableId: "",
      //表格高度
      tableHeight: 0,
      apartmentList: [],
      pagecount: 10,
      //历史导入字段
      historyChecked: "",
      //单选框
      radioVal: "",
      historyFiledList: [],
      listLoading: false,
      historyFiled: "",
      strsrvcentSel: "",
      //下拉项目名称
      objList: [],
      //备注
      remarkText: "",
      //姓名
      empname: "",
      //身份证
      idn: "",
      tableclumn: [],
      oldCluvalue: "",
      //表头内容
      tableTitle: [],
      path: "",
      instname: "",
      servusrname: "",
      servcentname: "",
      //项目名称
      custname: "",
      //筛选项目名称
      custname2: "",
      entid: "",
      ExcelSrc: {
        value: "",
        check: false,
        fileName: "",
      },
      checkAll: false,
      //字段选择默认选择
      checkedFields: [],
      // fields: this.$store.state.EMP.filed,
      fields: [],
      isIndeterminate: true,
      //手机号码格式是否正确
      totalcount: null,
      pageSize: 10,
      currpage: 1,
      //备注
      dialogVisible1: false,
      //导出
      dialogVisible4: false,
      drawer: false,
      //下拉筛选
      showDropScreen: -1,
      textarea: "",
      tableData: [],
      currFileData: [],
      //删除数据参数
      dltQuery: {
        strObjName: "",
        tableid: "",
        bookingRealMonth: "",
        belongMonth: "",
      },
    };
  },
  created() {
    let a = 3023.46;
    console.log("toFixed", a.toFixed(2).toLocaleString());
    let q = this.$route.query;
    (this.instname = q.instname),
      (this.servusrname = q.servusrname),
      (this.servcentname = q.servcentname),
      (this.custname = q.custname),
      (this.entid = q.entid);
    this.bookDate = q.bookDate;
    this.belongMonth = q.belongMonth;
    this.strTableId = q.StrTableId;
    if (q.StrTableId == "XZ_emp_FnncProCost") {
      //项目收支表费用
      this.activeName = "first";
      this.dltQuery.strObjName = "项目收支表费用";
      this.dltTableName = "项目收支表费用";
    }
    if (q.StrTableId == "XZ_emp_FnncProfit") {
      //利润表
      this.activeName = "second";
      this.dltQuery.strObjName = "利润表";
      this.dltTableName = "利润表";
    }
    if (q.StrTableId == "XZ_emp_FnncProjectInvoice") {
      //项目开票信息表
      this.activeName = "third";
      this.dltQuery.strObjName = "项目开票信息表";
      this.dltTableName = "项目开票信息表";
    }
    this.dltQuery.tableid = q.StrTableId;
    this.dateVals = parseTime(new Date(this.belongMonth), "{y}-{m}");
    this.calHeight();
    //固定字段
    this.getImportFiledList();
    this.getImprtInfo();
  },
  methods: {
    //切换tab
    async handleClick(tab) {
      // console.log('tab',tab, event);
      if (tab.index == "0") {
        //项目收支表费用
        this.strTableId = "XZ_emp_FnncProCost";
        this.dltQuery.tableid = "XZ_emp_FnncProCost";
        this.dltQuery.strObjName = "项目收支表费用";
        this.dltTableName = "项目收支表费用";
      }
      if (tab.index == "1") {
        //利润表
        this.strTableId = "XZ_emp_FnncProfit";
        this.dltQuery.tableid = "XZ_emp_FnncProfit";
        this.dltQuery.strObjName = "利润表";
        this.dltTableName = "利润表";
      }
      if (tab.index == "2") {
        //项目开票信息表
        this.strTableId = "XZ_emp_FnncProjectInvoice";
        this.dltQuery.tableid = "XZ_emp_FnncProjectInvoice";
        this.dltQuery.strObjName = "项目开票信息表";
        this.dltTableName = "项目开票信息表";
      }
      await this.getImportFiledList();
      this.currpage = 1;
      // this.pagecount = 10
      await this.getImprtInfo();
    },
    async selectMonth(date) {
      console.log("month", date);
    },
    //清除数据
    deleteHandle() {
      this.dltQuery.bookingRealMonth = "";
      this.dltQuery.belongMonth = "";
      this.delDialog = true;
    },
    //确认删除
    confirmDel() {
      if (this.strTableId != "XZ_emp_FnncProCost") {
        if (
          this.isNull2(this.dltQuery.belongMonth) ||
          this.isNull2(this.dltQuery.bookingRealMonth)
        ) {
          this.$message.warning("请选择记账月份和归属月份");
          return false;
        }
      } else {
        if (this.isNull2(this.dltQuery.bookingRealMonth)) {
          this.$message.warning("请选择记账月份");
          return false;
        }
      }
      xz.delfnncuserimport(this.dltQuery).then((res) => {
        if (res) {
          this.$message.success("删除成功！");
          setTimeout(() => {
            this.getImprtInfo();
          }, 1000);
          this.delDialog = false;
        } else {
          this.$message.fileid("删除失败！");
          this.delDialog = false;
        }
      });
    },
    // 上/下/月/年
    async fastWwitch(add, month) {
      if (month == "belongMonth") {
        this.dateVals = parseTime(new Date(this.belongMonth), "{y}-{m}-{d}");
        this.dateVals =
          add === 1
            ? this.getNextMonth(this.dateVals)
            : this.getPreMonth(this.dateVals);
        this.belongMonth = parseTime(new Date(this.dateVals), "{y}-{m}");
      } else if (month == "bookDate") {
        this.dateVals = parseTime(new Date(this.bookDate), "{y}-{m}-{d}");
        this.dateVals =
          add === 1
            ? this.getNextMonth(this.dateVals)
            : this.getPreMonth(this.dateVals);
        this.bookDate = parseTime(new Date(this.dateVals), "{y}-{m}");
      }
    },
    /**
     * 获取上一个月
     * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
     */
    getPreMonth(date) {
      var arr = date.split("-");
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      var t2 = year2 + "-" + month2 + "-" + day2;
      return t2;
    },
    /**
     * 获取下一个月
     * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
     */
    getNextMonth(date) {
      var arr = date.split("-");
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
        year2 = parseInt(year2) + 1;
        month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      var t2 = year2 + "-" + month2 + "-" + day2;
      return t2;
    },
    //获取表格高度
    calHeight() {
      this.tableHeight = Number(document.documentElement.clientHeight);
      console.log("height", this.tableHeight);
    },
    //翻页
    handleCurrentChange(val) {
      this.currpage = Number(val);
      this.getImprtInfo();
    },
    //改变列表加载数量
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currpage = 1;
      this.pagecount = Number(val);
      this.pageSize = parseInt(val);
      this.getImprtInfo();
    },
    //清空
    clear() {
      // this.custname = "";
      this.empname = "";
      this.idn = "";
      this.custname2 = "";
    },
    //点击历史导出单选框
    historyHandle(val) {
      this.checkedFields = [];
      if (val != " " && val != null) {
        this.tableclumn = JSON.parse(val);
        let historyData = JSON.parse(val);
        for (let index = 0; index < historyData.length; index++) {
          const elementHistoryData = historyData[index];
          this.checkedFields.push(elementHistoryData.name);
        }
      } else {
        this.tableclumn = [];
        this.checkedFields = [];
      }
      // console.log('rfd',this.checkedFields,this.tableclumn)
    },
    //获取所有字段信息
    async getImportFiledList() {
      const data = {
        pagecount: 100000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed: "all", //strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
        strTableId: this.strTableId,
      };
      this.fields = [];
      xz.getfinanceempcolumninf(data)
        .then((res) => {
          this.tableTitle = res.data;
          // console.log('固定导出字段',res)
          if (res && res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
              const elementRes = res.data[index];
              this.fields.push({
                name: elementRes.StrColumName,
                colname: elementRes.StrColumId,
              });
            }
            //去重
            this.currFileData = this.unique(this.fields);
            // console.log('ss',this.currFileData)
            this.fields = [];
            for (let index = 0; index < this.currFileData.length; index++) {
              const elementData = this.currFileData[index];
              this.fields.push(elementData.name);
            }
            // console.log('ss',this.fields)
          } else {
            this.tableTitle = [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      );
    },
    isNull2(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o === "" ||
        o == "null" ||
        o == []
      );
    },
    //备注
    addRemarks(row) {
      this.emprow = row;
      // console.log('row',row)
      this.dialogVisible1 = true;
      this.remarkText = this.emprow.StrRemark;
    },
    //确认备注
    confirmRemark() {
      const data = {
        tableid: "XZ_emp_UserBase",
        excelpath: this.emprow.StrExcelPath,
        execlline: this.emprow.IntExcelLine,
        cluname: "StrRemark",
        cluvalue: this.remarkText,
      };
      xz.editEmployeeInfo(data).then((res) => {
        if (res == true) {
          this.$message({
            message: "雇员信息修改成功！",
            type: "success",
          });
          this.getImprtInfo();
        } else {
          this.$message.error("雇员信息修改失败！");
          this.getImprtInfo();
        }
      });
      this.dialogVisible1 = false;
    },
    //导出字段全选
    handleCheckAllChange(val) {
      this.tableclumn = this.currFileData;
      this.checkedFields = val ? this.fields : [];
      if (val == false) {
        this.tableclumn = [{ colname: "StrIdCard", name: "身份证号码" }];
      }
      this.isIndeterminate = false;
      // console.log('d', val, this.checkedFields, this.tableclumn)
    },
    //导出字段选择
    handleCheckedCitiesChange(value) {
      // console.log('val', value)
      this.tableclumn = [{ colname: "StrIdCard", name: "身份证号码" }];
      for (let index = 0; index < this.currFileData.length; index++) {
        // const elementFileDatas = this.currFileData[index];
        if (value != "" && value != null) {
          for (let i = 0; i < value.length; i++) {
            // const elementVal = value[index];
            if (value[i] == this.currFileData[index].name) {
              this.tableclumn.push(this.currFileData[index]);
            }
          }
        } else {
          this.tableclumn = [{ colname: "StrIdCard", name: "身份证号码" }];
        }
      }
      //去重
      this.tableclumn = this.unique(this.tableclumn);
      // console.log('val', this.tableclumn)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.fields.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.fields.length;
    },
    //去重
    unique(arr) {
      const resList = new Map();
      return arr.filter(
        (arr) => !resList.has(arr.name) && resList.set(arr.name, 1)
      );
    },
    //确认导出
    confirmExport() {
      const data = {
        custname: this.custname,
        outtype: "0",
        tableid: "XZ_emp_UserBase",
        roletype: localStorage.loginRoletype,
        tableclumn: this.tableclumn,
      };
      var Promise = xz.exportEmp(data);
      this.$router.push({
        path: "/operationRecord",
        query: {
          showPage: 1,
          isActive: 1,
          custname: this.custname,
          qStstus: 1,
        },
      });
      this.dialogVisible4 = false;
    },
    //导出
    exportInfo() {
      this.dialogVisible4 = true;
      this.radioVal = "";
      this.checkedFields = [];
      xz.getHistoryFiled().then((res) => {
        if (res.length && res.length > 0) {
          res.forEach((l) => {
            l.dtOputDate = l.dtOputDate.substring(0, 10);
            if (l.Key != "" && l.Key != null) {
              let historyData = JSON.parse(l.Key);
              // console.log('dd',historyData)
              this.historyFiledList = historyData;
            }
          });
          this.historyFiled = res;
          this.radioVal = res[0].Key;
          if (res[0].Key != "" && res[0].Key != null) {
            for (
              let index = 0;
              index < JSON.parse(res[0].Key).length;
              index++
            ) {
              const elementsData = JSON.parse(res[0].Key)[index];
              this.checkedFields.push(elementsData.name);
            }
            this.tableclumn = JSON.parse(res[0].Key);
          } else {
            this.tableclumn = [];
          }
        } else {
          this.historyFiled = [];
          this.tableclumn = [];
        }
      });
      console.log("this.radioVal", this.radioVal);
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //获取表格路径
    getExcelPath() {
      const data = {
        pagecount: 1,
        currpage: 1,
        excelname: "",
        tableid: "",
        instname: "",
        impdate: "",
      };
      xz.getPathInfo(data).then((res) => {
        this.path = res.data[0].StrExcelPath;
        this.getImprtInfo();
      });
    },
    //获取花名册信息
    async getImprtInfo() {
      this.listLoading = true;
      const qdata = {
        custname:
          this.strTableId == "XZ_emp_Fnnc" ? this.custname : this.custname2,
        tableid: this.strTableId,
        pagecount: this.pagecount,
        currpage: this.currpage,
        username: this.empname,
        idcard: this.idn,
        strcontracttype: this.strcontracttype,
        strnativeplace: this.strnativeplace,
        strcityzentype: this.strcityzentype,
        strusername: this.strusername,
        bookingRealMonth: this.bookDate,
        belongMonth: this.belongMonth,
      };
      xz.getfinancecurrdata(qdata)
        .then((res) => {
          let i = 1 + (this.currpage - 1) * 10;
          if (res.data && res.data.length > 0) {
            res.data.forEach((l) => {
              if (!this.isNull2(l.StrIdCard) && l.StrIdCard.indexOf("-") > -1) {
                let arr = l.StrIdCard.split("-");
                l["StrIdCard"] = arr[0];
              }
            });
            this.tableData = res.data;
            this.totalcount = parseInt(res.totalcount);
          } else {
            this.tableData = [];
            this.totalcount = 0;
          }
          this.listLoading = false;
          this.showDropScreen = -1;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //格式出错字体变红
    columnStyle({ row, column, rowIndex, columnIndex }) {
      // console.log( row, column, rowIndex, columnIndex)
      if (row.repeatJudge == "true") {
        if (column.label == "档案号") {
          return "background-color:rgb(255,199,206)";
        }
        if (column.label == "身份证号码") {
          return "background-color:rgb(255,199,206)";
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-tabs--top {
  width: 99%;
  background-color: #fff;
}
.page-roster .search {
  height: 32px;
  padding: 5px 15px;
  margin-right: 10px;
  border-radius: 5px;
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19bd92;
}
.historyFiled {
  margin-top: 20px;
}
.historyFiled .el-radio-group {
  display: inline-block !important;
  margin-right: 10px;
  margin-top: 10px;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
:focus {
  outline: 0;
}
.top-right {
  display: flex;
  align-items: center;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selectCell {
  display: flex;
}
.lineTitle {
  line-height: 48px;
}
.page-roster .dlt_btn {
  display: flex;
  justify-content: flex-end;
  background: #fff;
  padding: 10px 0 10px 0;
  width: 99%;
}
.dlt_btn .el-button {
  margin-right: 15px;
}
</style>

<style>
.customerRosterTable .el-table td {
  padding: 8px 0;
}
.customerRosterTable .el-table th {
  padding: 12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 120px !important;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card > .el-tabs__content {
  max-height: 200px;
  overflow-y: scroll;
}
.dialog .el-card__body {
  max-height: 208px;
  overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
  margin-left: 10px;
}
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19bd92;
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #19bd92;
}
.tagArea .el-checkbox__inner:hover {
  border-color: #19bd92;
}
.tagArea .el-tag--plain.el-tag--success {
  color: #19bd92;
}
.tagArea
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92;
}
.tagArea .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #19bd92;
}
.tableEditInput .el-input__inner {
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0;
  font-size: 13px;
}
.tableEditInput .el-input__icon {
  line-height: 25px;
}
.el-select-dropdown__item.selected {
  color: #19bd92 !important;
}
.historyFiled .el-radio-group {
  display: flex;
}
.exactDate .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.exactDate .el-input__icon {
  line-height: 32px;
}
.block .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 160px;
}
</style>
